import { focusElement, waitForRenderThenFocus } from 'platform/utilities/ui';

export const VALIDATION_ALERT_HEADING_ID = 'address-validation-alert-heading';

export const validationAlertHeadingSelector = `#${VALIDATION_ALERT_HEADING_ID}`;

export const editLinkSelector = addressValidationType =>
  `#${addressValidationType}-edit-link`;

// The web component alert has no focus/auto-scroll method of its own, unlike
// the React component it replaced, so focus is set once the heading renders.
export const focusValidationAlertHeading = () =>
  waitForRenderThenFocus(validationAlertHeadingSelector);

// Returns focus to the link that opened this view when it goes away.
export const focusEditLink = addressValidationType =>
  focusElement(editLinkSelector(addressValidationType));
